import React from 'react';
import { checkString, checkArray } from '../helpers/global'

const Feature = props => {

  const {data} = props;
  console.log(data)
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};
  if (checkArray(data.image_data)){
    img_src = data.image_data.toString();
  }
  if (!img_src) {

    img_src = data.image_url;
  }
  img_alt = data.image_alt;

  if (checkArray(data.focal_point)){
    focal_point = data.focal_point;
     combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }

  return (

    <div className={"grid-item col-2  "} >
      <a href={data.url} className={"grid-item-inner bg-"}>
       {data.image_src &&

           <div className="image-container" tabindex="-1">
           <div class="tags">
           {checkString(data.category) &&
             <div className="category font-medium font-label">{data.category}</div>
           }

           </div>
            <img loading="lazy" src={data.image_src}  alt={data.image_alt}  />
            {data.display_date && checkString(data.display_date) &&
              <div className=" date" dangerouslySetInnerHTML={{__html: data.display_date}} />
            }
           </div>
        
       }
        <div className="content">

          <div dangerouslySetInnerHTML={{__html: data.info}}/>

          <h4 dangerouslySetInnerHTML={{__html: data.title}}/>
          
          {checkString(data.text) &&
            <p className="slot-text" dangerouslySetInnerHTML={{__html: data.text}} />
          }
    

       
        




        </div>
        <div className="button-no-text" aria-label={data.link_title}>
             {data.link_title}
      </div>
      </a>
    </div>
  )
}

export default Feature;
